
import { Component, Vue } from 'vue-property-decorator'
import MallClassifyService from '@/biz/service/Mall/MallClassifyService'

@Component
export default class MallClassifyIndex extends Vue {
  private MallClassifyService = MallClassifyService
}
